// Navegação pelo endereço depois do # (funciona instalado e sem servidor).
//   #/veiculos/123?tipo=implemento → tela de veículo com { id: '123' } e busca.tipo
const rotas = [];
let desenhar = null;
let geracao = 0;

export function definirRota(padrao, tela, opcoes = {}) {
  rotas.push({ partes: padrao.split('/').filter(Boolean), tela, opcoes });
}

export function caminhoAtual() {
  return location.hash.replace(/^#/, '') || '/';
}

export function ir(caminho, { substituir = false } = {}) {
  const alvo = `#${caminho}`;
  if (location.hash === alvo) {
    renderizar();
    return;
  }
  if (substituir) {
    history.replaceState(null, '', alvo);
    renderizar();
  } else {
    location.hash = alvo;
  }
}

// Para ações que terminam depois de um tempo (salvar, ativar placa…): só
// navega ou redesenha se a pessoa ainda estiver na mesma tela.
export function nestaTela() {
  const aqui = caminhoAtual();
  const ainda = () => caminhoAtual() === aqui;
  return {
    ainda,
    ir: (caminho, opcoes) => {
      if (ainda()) ir(caminho, opcoes);
    },
    renderizar: () => {
      if (ainda()) renderizar();
    },
  };
}

export function encontrar(caminho) {
  const [base, consulta = ''] = caminho.split('?');
  const partes = base.split('/').filter(Boolean);
  for (const rota of rotas) {
    if (rota.partes.length !== partes.length) continue;
    const params = {};
    const casa = rota.partes.every((p, i) => {
      if (p.startsWith(':')) {
        params[p.slice(1)] = decodeURIComponent(partes[i]);
        return true;
      }
      return p === partes[i];
    });
    if (casa) return { rota, params, busca: new URLSearchParams(consulta) };
  }
  return null;
}

// `aoDesenhar({ rota, params, busca, geracao })` é quem monta a tela.
export function iniciarRotas(aoDesenhar) {
  desenhar = aoDesenhar;
  window.addEventListener('hashchange', renderizar);
  renderizar();
}

export function renderizar() {
  const minha = ++geracao;
  return desenhar?.({ caminho: caminhoAtual(), encontrado: encontrar(caminhoAtual()), ehAtual: () => minha === geracao });
}
